// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.league-team-edit-member__form{
    padding: 32px;
}

.league-team-edit-member__subtitle .baloa-table-column{
    color: var(--primary-dark-color);
}

.league-team-edit-member__row{
    display: flex;
    align-items: center;
    padding-top: 16px;
}

.league-team-edit-member__row__label .baloa-username{
    color: var(--primary-very-dark-color);
}

.league-team-edit-member__row-full{
    width: 100%;
}

.league-team-edit-member__row-half{
    width: 50%;
}

.league-team-edit-member__row-half:first-child{
    margin-right: 12px;
}

.league-team-edit-member__row__input__input .input-field-input{
    background: var(--white-color);
    border: 1px solid var(--new-gray-background-color);
}

.league-team-edit-member__row__input__input .input-field-input:disabled{
    color: var(--disabled-color);
}

.input-field.league-team-edit-member__row__input__input, .league-team-edit-member__row__input__select-input{
    margin: unset;
}

.league-team-edit-member__row__input__select-input .select-field-input{
    background: var(--white-color);
    border: 1px solid var(--new-gray-background-color);
}

.league-team-edit-member__row__input__select-input .select-field-input:disabled{
    color: var(--disabled-color);
}


.league-team-edit-member__row__input__select-input .MuiInput-underline:hover:not(.Mui-disabled):before, 
.league-team-edit-member__row__input__select-input .MuiInput-underline:before{
    border-bottom: unset;
}

.league-team-edit-member__footer{
    display: flex;
    align-items: center;
    justify-content: flex-end;
    border-top: 1p solid var(--new-gray-background-color);
    padding-top: 16px;
    margin-top: 32px;
}

.league-team-edit-member__footer .text-button{
    color: var(--basic-gray-color);
}

.league-team-edit-member__message.baloa-username{
    color: var(--primary-very-dark-color);
    margin-bottom: 32px;
    align-items: center;
    display: flex;
}

.league-team-edit-member__row-error{
    margin-left: auto;
}`, "",{"version":3,"sources":["webpack://./src/app/leagues/components/league-team-edit-member-modal/LeagueTeamEditMemberModalComponent.styles.css"],"names":[],"mappings":"AAAA;IACI,aAAa;AACjB;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,iBAAiB;AACrB;;AAEA;IACI,qCAAqC;AACzC;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,8BAA8B;IAC9B,kDAAkD;AACtD;;AAEA;IACI,4BAA4B;AAChC;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,8BAA8B;IAC9B,kDAAkD;AACtD;;AAEA;IACI,4BAA4B;AAChC;;;AAGA;;IAEI,oBAAoB;AACxB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,yBAAyB;IACzB,qDAAqD;IACrD,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,qCAAqC;IACrC,mBAAmB;IACnB,mBAAmB;IACnB,aAAa;AACjB;;AAEA;IACI,iBAAiB;AACrB","sourcesContent":[".league-team-edit-member__form{\n    padding: 32px;\n}\n\n.league-team-edit-member__subtitle .baloa-table-column{\n    color: var(--primary-dark-color);\n}\n\n.league-team-edit-member__row{\n    display: flex;\n    align-items: center;\n    padding-top: 16px;\n}\n\n.league-team-edit-member__row__label .baloa-username{\n    color: var(--primary-very-dark-color);\n}\n\n.league-team-edit-member__row-full{\n    width: 100%;\n}\n\n.league-team-edit-member__row-half{\n    width: 50%;\n}\n\n.league-team-edit-member__row-half:first-child{\n    margin-right: 12px;\n}\n\n.league-team-edit-member__row__input__input .input-field-input{\n    background: var(--white-color);\n    border: 1px solid var(--new-gray-background-color);\n}\n\n.league-team-edit-member__row__input__input .input-field-input:disabled{\n    color: var(--disabled-color);\n}\n\n.input-field.league-team-edit-member__row__input__input, .league-team-edit-member__row__input__select-input{\n    margin: unset;\n}\n\n.league-team-edit-member__row__input__select-input .select-field-input{\n    background: var(--white-color);\n    border: 1px solid var(--new-gray-background-color);\n}\n\n.league-team-edit-member__row__input__select-input .select-field-input:disabled{\n    color: var(--disabled-color);\n}\n\n\n.league-team-edit-member__row__input__select-input .MuiInput-underline:hover:not(.Mui-disabled):before, \n.league-team-edit-member__row__input__select-input .MuiInput-underline:before{\n    border-bottom: unset;\n}\n\n.league-team-edit-member__footer{\n    display: flex;\n    align-items: center;\n    justify-content: flex-end;\n    border-top: 1p solid var(--new-gray-background-color);\n    padding-top: 16px;\n    margin-top: 32px;\n}\n\n.league-team-edit-member__footer .text-button{\n    color: var(--basic-gray-color);\n}\n\n.league-team-edit-member__message.baloa-username{\n    color: var(--primary-very-dark-color);\n    margin-bottom: 32px;\n    align-items: center;\n    display: flex;\n}\n\n.league-team-edit-member__row-error{\n    margin-left: auto;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
